<template>
  <div class="fixed-btn-view" :class="{'fixed-btn': isFixedBtn }">
    <div class="fixed-btn-view__cont">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  methods: {
    // 判断是否有滚动条：vertical纵轴，horizontal横轴
    hasScrolled (element, direction) {
      if (direction === 'vertical') {
        return element.scrollHeight > element.clientHeight
      } else if (direction === 'horizontal') {
        return element.scrollWidth > element.clientWidth
      }
    }
  },
  computed: {
    ...mapState({
      isFixedBtn: state => state.login.isFixedBtn
    })
  },
  mounted () {
    setTimeout(() => {
      const cont1 = document.getElementById('layoutCont')
      const isFixed = cont1.scrollHeight > cont1.clientHeight
      this.$store.commit('SET_IS_FIXED_BTN', isFixed)

      cont1.addEventListener('scroll', (e) => {
        const { target } = e
        if (target.scrollTop + target.clientHeight > target.scrollHeight - 100) {
          this.$store.commit('SET_IS_FIXED_BTN', false)
        } else if (target.scrollHeight > target.clientHeight) {
          this.$store.commit('SET_IS_FIXED_BTN', true)
        }
      })
    }, 100)
  },
  activated () {
    this.$store.commit('SET_IS_FIXED_BTN', true)
  },
  destroyed () {
    this.$store.commit('SET_IS_FIXED_BTN', false)
  }
}
</script>
<style lang="less">
  .fixed-btn-view {
    width: 100%;
    background: #fff;
    position: absolute;
    left: 0px;
    bottom: 0px;
    border-top: 1px solid #EEEEEE;
    &__cont {
      width: 100%;
      // max-width: 1200px;
      margin:0 auto;
      padding: 12px 16px;
      text-align: right;
    }
  }
  .fixed-btn {
    position: fixed;
    left: 0px;
    bottom: 0px;
    box-shadow: 0px -1px 10px #cfcfcf;
  }
</style>
